export default __webpack_public_path__ + "static/media/user.38d7762e.png";